import type { FC, ReactNode } from "react";

import { Text } from "../Text";
import { Flex } from "../Flex";
import { containerStyle } from "./DebugLabel.css";

type DebugLabelProps = {
  children: ReactNode;
  trailing?: ReactNode;
};

export const DebugLabel: FC<DebugLabelProps> = ({ children, trailing }) => (
  <Flex className={containerStyle} direction="column" align="center">
    <Text variant="monospace">{children}</Text>
    {trailing}
  </Flex>
);
